import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fixed top-0 px-5 right-0 z-50 w-96 bg-white bg-opacity-90" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = ["onClick"]

import {
  ref,
  onMounted,
  onBeforeUnmount,
  watch,
  computed,
} from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';

import { NotificationI } from '@/store/notifications/state';


export default /*@__PURE__*/_defineComponent({
  __name: 'notifications',
  setup(__props) {

const store = useStore();

const notifications = computed<NotificationI[]>(() => store.state.notifications.notifications);
// get the current date unix timestamp
const now = ref(moment().format('X'));
const interval = ref(0);

function updateNow() {
  interval.value = setInterval(() => {
    now.value = moment().format('X');
  }, 1000);
}

function removeNotification(id: string) {
  store.commit('notifications/removeNotification', id);
}

onMounted(async () => {
  updateNow();
});

// watch each second
watch(now, (newVal) => {
  if (notifications.value.length === 0) {
    return;
  }

  const notificationsReverse = [...notifications.value].reverse();

  // get the last one
  const lastNotification = notificationsReverse[notificationsReverse.length - 1];
  if (lastNotification) {
    const diff = lastNotification.closeIn - Number(newVal);
    if (diff < 0) {
      removeNotification(lastNotification.id);
    }
  }
});

onBeforeUnmount(() => {
  clearInterval(interval.value);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notification, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["mt-2 p-2 border-l-4 shadow mb-2", {
        'border-red-500 bg-red-100': notification.type === 'error',
        'border-green-500 bg-green-100': notification.type === 'success',
        'border-blue-500 bg-blue-100': notification.type === 'info',
        'border-yellow-500 bg-yellow-100': notification.type === 'warning',
      }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mr-2" }, [
              _createElementVNode("i", { class: "fas fa-bell" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(notification.title), 1),
              _createElementVNode("p", null, _toDisplayString(notification.message), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: ($event: any) => (removeNotification(notification.id)),
              class: "p-1 rounded text-white bg-black"
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "fas fa-times" }, null, -1)
            ]))], 8, _hoisted_5)
          ])
        ])
      ], 2))
    }), 128))
  ]))
}
}

})